import type { PaymentPeriod } from "app/components/PackageSwitcher/consts/paymentPeriod";
import { FetchResponseError, HTTP_METHOD, withFullResponseSymbol } from "app/services/fetchService/defaults";
import { getResponseError } from "app/services/fetchService/utils/getResponseError";

import type { IGetCurrentPackageSwitchInformationResponse } from "./useSwitchPackagePopup.types";

const PREVIEW_SWITCH_PACKAGE_URL = "/api/notouch/packages/preview-switch-package";
const SWITCH_CURRENT_PACKAGE_URL = "/api/notouch/packages/switch-package";

export interface ISwitchPackagePreviewParams {
    targetPackageName: string;
    targetPackagePeriod: PaymentPeriod;
}

export interface ISwitchCurrentPackagePayload {
    targetPackagePeriod: PaymentPeriod;
    targetPackageTitle: string;
}

const throwIfNotOk = async (response: Response, method?: string, body?: object): Promise<Response> => {
    if (response.ok) {
        return response;
    }

    throw await getResponseError({
        error: new FetchResponseError(response.statusText, response, withFullResponseSymbol),
        method,
        url: response.url,
        body,
    });
};

export const fetchSwitchPackagePreview = async ({
    targetPackageName,
    targetPackagePeriod,
}: ISwitchPackagePreviewParams): Promise<IGetCurrentPackageSwitchInformationResponse> => {
    const queryParams = new URLSearchParams({
        targetPackageName,
        targetPackagePeriod,
    });

    const response = await fetch(`${PREVIEW_SWITCH_PACKAGE_URL}?${queryParams.toString()}`);
    await throwIfNotOk(response, HTTP_METHOD.get);

    return (await response.json()) as IGetCurrentPackageSwitchInformationResponse;
};

export const submitSwitchCurrentPackage = async (payload: ISwitchCurrentPackagePayload): Promise<void> => {
    const response = await fetch(SWITCH_CURRENT_PACKAGE_URL, {
        method: "POST",
        headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    await throwIfNotOk(response, HTTP_METHOD.post, payload);
};
